let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = '/api'

} else if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://www.yilupei.com:8000'
}
export default baseURL